module.exports = __webpack_public_path__ + "img/partner_35.867c1896.png";